import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomAppService } from '../../../_services/_content/customApp.service';
import { MatDialog } from '@angular/material/dialog';
import { CheckRequirementsComponent } from '../../_techcheck/check-requirements/check-requirements.component';
import { ICustomApp, ILogin, IRegistration, IRegistrationStandard } from '@sv/interfaces';
import { RegistrationService } from 'src/app/_services/_content/registration.service';
import { LoginService } from 'src/app/_services/_content/login.service';
import { TicketcodeAuthService } from 'src/app/_services/_auth/ticketcode-auth.service';

@Component({
  selector: 'app-registration-success',
  templateUrl: './registration-success.component.html',
  styleUrls: ['./registration-success.component.scss']
})
export class RegistrationSuccessComponent implements OnInit {
  customApp: ICustomApp;
  registration: IRegistration;
  settings: IRegistrationStandard;
  login: ILogin;

  constructor(
    private router: Router,
    private customAppService: CustomAppService,
    private dialog: MatDialog,
    private registrationService: RegistrationService,
    private loginService: LoginService,
    private route: ActivatedRoute,
    private ticketcodeAuthService: TicketcodeAuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      const preview = params.preview;

      if (preview) {
        this.ticketcodeAuthService.logout();
        return;
      }
    });

    this.customAppService.getCustomAppListener().subscribe(async (app) => {
      this.customApp = app;
      if (typeof this.customApp.registration === 'string') {
        this.registration = await this.registrationService.getRegistrationById(this.customApp.registration);
        this.settings = this.registration.settings as IRegistrationStandard;
      } else {
        this.registration = this.customApp.registration;
        this.settings = this.registration.settings as IRegistrationStandard;
      }
      if (typeof this.customApp.login === 'string') {
        this.login = await this.loginService.getLoginById(this.customApp.login);
      } else {
        this.login = this.customApp.login;
      }
    });
  }

  goToPlattform() {
    this.router.navigate(['/login']);
  }

  techCheck() {
    if (screen.width > 699) {
      this.dialog.open(CheckRequirementsComponent, { width: '60%', height: '80%' });
    } else {
      this.dialog.open(CheckRequirementsComponent, { maxWidth: '100vw', maxHeight: '100vh', height: '100%', width: '100%' });
    }
  }
}
